export const noop = (event) => {
  event.preventDefault();
  event.stopPropagation();
};
